import React, { useState, useEffect, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { AppContext } from '@/AppContext';
import { useParams } from 'react-router-dom';
import { Link, Typography } from '@mui/material';

import RegFormToolbar from './components/RegFormToolbar';
import RegFormSettings from './components/RegFormSettings';
import RegFormMail from './components/RegFormMail';
import RegFormClose from './components/RegFormClose';
import { errorsToForm } from '@/components/Forms/form_utils';
import * as _ from 'underscore';

const PREFIX = 'OnlineRegistration';

const classes = {
  link: `${PREFIX}-link`,
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.link}`]: {
    marginTop: '8px',
  },

  [`&.${classes.root}`]: {
    padding: theme.spacing(3),
  },
}));

const OnlineRegistration = () => {
  const appContext = useContext(AppContext);
  const { mid: meetupId } = useParams();
  const [settings, setSettings] = useState(undefined);
  const [regForm, setRegForm] = useState(undefined);
  const [error, setError] = useState(undefined);

  useEffect(() => {
    appContext.configApi.getSettings(meetupId).then(({ data }) => {
      setSettings(data);
      setRegForm(data.regForm);
    });
  }, [meetupId]);

  const save = (data, form) => {
    appContext.configApi.getSettings(meetupId).then(({ data: original }) => {
      data = _.extend(original.regForm, data);

      appContext.configApi
        .setRegFormSettings(meetupId, data)
        .then(({ data: newData }) => {
          setRegForm(newData);
          setError(undefined);
          if (form) {
            Object.keys(form.formState.errors).forEach(k => form.clearErrors(k));
          }
        })
        .catch(error => {
          const data = error.response.data;
          setError(data.message);
          if (form) {
            errorsToForm(form)(error);
          }
        });
    });
  };

  if (!regForm) {
    return null;
  }

  return (
    <Root className={classes.root}>
      <RegFormToolbar regForm={regForm} save={save} />
      <RegFormSettings regForm={regForm} fields={settings.fields.fields} save={save} />
      <RegFormMail regForm={regForm} fields={settings.fields.fields} save={save} />
      <RegFormClose regForm={regForm} save={save} />
    </Root>
  );
};

export default OnlineRegistration;
